module.exports = __webpack_public_path__ + "img/kun.5f0c3449.png";